export default __webpack_public_path__ + "static/media/BootsSharp-Regular.9dcd0f25.woff2";